// Lightweight Google Analytics 4 wrapper.
// The gtag.js script and `gtag('config', ...)` call live in /public/index.html.
// We expose two helpers:
//   - trackPageview(path): fires a virtual page_view for SPA route changes.
//   - trackEvent(name, params): fires a custom GA4 event.
// Both are safe to call even when gtag isn't loaded yet (ad-blocker, dev mode).

export const GA_MEASUREMENT_ID = "G-VJH1WTSEJR";

function safeGtag(...args) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag(...args);
    }
  } catch {
    /* swallow – analytics must never break the app */
  }
}

export function trackPageview(path) {
  if (!path) return;
  safeGtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_MEASUREMENT_ID,
  });
}

export function trackEvent(name, params = {}) {
  if (!name) return;
  safeGtag("event", name, { send_to: GA_MEASUREMENT_ID, ...params });
}
